
module.exports = {
	REQUEST_BODYPART: "REQUEST_BODYPART",
	RECEIVE_BODYPART: "RECEIVE_BODYPART",
	REQUEST_EDUCATION: "REQUEST_EDUCATION",
	RECEIVE_EDUCATION: "RECEIVE_EDUCATION",
	REQUEST_SYMPTOM: "REQUEST_SYMPTOM",
	RECEIVE_SYMPTOM: "RECEIVE_SYMPTOM",
    REQUEST_DISEASE: "REQUEST_DISEASE",
	RECEIVE_DISEASE: "RECEIVE_DISEASE",
    REQUEST_TOOLBOX: "REQUEST_TOOLBOX",
	RECEIVE_TOOLBOX: "RECEIVE_TOOLBOX",
	SET_ACTIVE_BODYPARTS: "SET_ACTIVE_BODYPARTS",
	SET_ACTIVE_EDUCATION_TOGGLE: "SET_ACTIVE_EDUCATION_TOGGLE",
    SET_THANKS_REGISTERING_MESSAGE: "SET_THANKS_REGISTERING_MESSAGE",
    CLEAR_THANKS_REGISTERING_MESSAGE: "CLEAR_THANKS_REGISTERING_MESSAGE"
};



// WEBPACK FOOTER //
// ./src/common/modules/education/constants.js